import lloydsIllustrationPeople from '../../assets/common/lloyds-illustration-people.svg';
import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const fullSignatoryPage: AppContent['fullSignatoryPage'] = {
  fullSignatoryPageContent: [
    {
      serviceName: 'Online for Business',
      header: 'Are you a Full Signatory on the bank mandate?',
      content:
        'You are a Full Signatory if you can change who accesses your business accounts, authorise payments and apply for new products and services.',
      imageAltText: 'Lloyds banking People Illustration',
      imageSrc: lloydsIllustrationPeople,
      faqHeader: 'Need some help?',
      yesBtn: 'Yes',
      yesBtnHref: '/approve-your-registration',
      noBtn: 'No',
      noBtnHref: '/three-steps-to-register',
      previousLink: 'Previous',
      previousHref: '/',
      faq: [
        {
          question: 'How do I know if I’m a full signatory?',
          answer:
            'Full signatories are named on the bank mandate – the set of instructions given to us when the business account was opened. Only full signatories can apply for loans and overdrafts and open and close accounts in a branch, by post or phone. Still not sure? Please contact us for some help.',
        },
        {
          question: 'What is a bank mandate and signing instructions?',
          answer: `A bank mandate is the set of instructions given to us when the business account is opened. It includes:
                    Signatories The names and signatures of the people with access to the business account, products and services.
                    Business signing instructions How many signatories are needed to authorise payments and other tasks in branch, by post or phone.`,
        },
        {
          question: 'How can I find out what’s on the bank mandate?',
          answer:
            'If you can’t find your bank mandate, please contact us for some help.',
        },
        {
          question: 'Contact us',
          answer: `Online for Business Queries
                    0345 300 0116
                    If you're calling from outside the UK or prefer not to use our 0345 number, call: +44 207 649 9437.
                    
                    Our Online for Business helpdesk opening hours are: Monday to Friday 7.00am - 8.00pm, Saturday 9.00am - 2.00pm. This is excluding bank holidays.
                    You can call us using Relay UK if you have a hearing or speech impairment. There's more information on the Relay UK help pages https://www.relayuk.bt.com/.
                    
                    Sign Video services are also available if you're Deaf and use British Sign Language.
                    
                    If your account is held in Jersey, Guernsey or the Isle of Man, you can contact your Relationship Manager from Monday to Friday between 9am – 5pm on the following number:
                    01539 871570`,
        },
      ],
    },
  ],
};

export default fullSignatoryPage;
